import React, { useState } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { OnboardingAddProduct } from './OnboardingAddProduct';
import { OnboardingAuth } from './OnboardingAuth';

interface OnboardingFlowProps {
  isOpen: boolean;
  onClose: () => void;
}

interface ProductData {
  name: string;
  price: number;
  category: string;
  url?: string;
}

export const OnboardingFlow = ({ isOpen, onClose }: OnboardingFlowProps) => {
  const [step, setStep] = useState<'product' | 'auth'>('product');
  const [productData, setProductData] = useState<ProductData | null>(null);

  const handleProductSubmit = (data: ProductData) => {
    setProductData(data);
    setStep('auth');
  };

  const handleAuthComplete = () => {
    onClose();
    // Die Navigation zum Dashboard erfolgt automatisch nach der Registrierung
  };

  const handleBack = () => {
    if (step === 'auth') {
      setStep('product');
    } else {
      onClose();
    }
  };

  const handleCloseFlow = () => {
    setStep('product');
    setProductData(null);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleCloseFlow}>
      <DialogContent className="sm:max-w-[600px] bg-gradient-to-br from-white to-emerald-50/30 border-emerald-200/50 max-h-[90vh] overflow-y-auto">
        {step === 'product' ? (
          <OnboardingAddProduct 
            onSubmit={handleProductSubmit} 
            onClose={handleCloseFlow}
          />
        ) : (
          <OnboardingAuth 
            productData={productData!}
            onComplete={handleAuthComplete}
            onBack={handleBack}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
